import { render } from "./NewFromSystemTemplate.vue?vue&type=template&id=461f4199"
import script from "./NewFromSystemTemplate.vue?vue&type=script&lang=js"
export * from "./NewFromSystemTemplate.vue?vue&type=script&lang=js"

import "./NewFromSystemTemplate.vue?vue&type=style&index=0&id=461f4199&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__